import { setAriaProp, trapFocus } from "@common/utilities.js";

export default class HeaderNavigation {
	constructor(config) {
		this.el = config.el || document.querySelector(".header--navigation");
		this.menuClose = this.el.querySelector(".header__close");
		this.menuOpen = this.el.querySelector(".header__burger");
		this.menuOpenClass = "header--show-panel";
		this.menuPanel = this.el.querySelector(
			".header__navigation--small-panel"
		);
		this.activeLevelsClass = ".active-level .sub-navigation__levels";
		this.HeaderNavBgClass = ".header__navigation--header-bg";
		this.HeaderNavBgActiveClass = "header__navigation--active";
		this.subNavActiveClass = ".sub-navigation__level-item--active";
		this.init();
		this.panelVisible = false;
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {
		if (this.menuOpen && this.menuClose) {
			this.menuOpen.addEventListener("click", () => {
				this.showPanel();
			});
			this.menuClose.addEventListener("click", () => {
				this.hidePanel();
			});
			this.el.addEventListener("keydown", (e) => {
				if (e.code === "Escape" && this.panelVisible) {
					this.hidePanel();
				}
			});
			trapFocus(this.el);
		}
	}

	showPanel() {
		this.panelVisible = true;
		const self = this;
		this.el.classList.add(this.menuOpenClass);

		let themeColor = this.el.querySelector(
			".header__navigation--small-panel.active"
		).dataset.theme;

		this.el.querySelector(".header__inherit").classList.add(themeColor);

		setAriaProp(this.menuPanel, "hidden", false);
		this.menuPanel.style.cssText = "display: block; visibility: visible";

		document.getElementsByTagName("html")[0].style.overflow = "hidden";

		this.el.querySelector(this.activeLevelsClass).style.visibility =
			"hidden";
		setAriaProp(
			self.el.querySelector(self.activeLevelsClass),
			"hidden",
			true
		);

		this.el.querySelectorAll(self.HeaderNavBgClass).forEach((el) => {
			if (el.classList.contains("active")) {
				el.classList.add(self.HeaderNavBgActiveClass);
			}
		});

		this.menuClose.focus();
	}
	hidePanel() {
		this.panelVisible = false;
		const self = this;
		this.el.classList.remove(this.menuOpenClass);

		let themeColor = this.el.querySelector(
			".header__navigation--small-panel.active"
		).dataset.theme;

		this.el.querySelector(".header__inherit").classList.remove(themeColor);

		setAriaProp(this.menuPanel, "hidden", true);
		this.menuPanel.style.cssText = "display: none; visibility: hidden";

		document.getElementsByTagName("html")[0].style.overflow = "unset";

		this.el.querySelector(this.activeLevelsClass).style.visibility =
			"visible";
		setAriaProp(
			self.el.querySelector(self.activeLevelsClass),
			"hidden",
			false
		);

		this.el.querySelectorAll(self.HeaderNavBgClass).forEach((el) => {
			if (el.classList.contains("active")) {
				el.classList.remove(self.HeaderNavBgActiveClass);
			}
		});

		this.menuOpen.focus();
	}
}
